import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  listDurableFacilitatedSessions,
} from "../services/durableFacilitatedSessionApi";

function formatDate(value) {
  if (!value) {
    return "Unknown date";
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime())
    ? "Unknown date"
    : date.toLocaleString();
}

function activityLabel(activity = {}) {
  return (
    activity.compatibilityToolName ||
    activity.normalizedActivityType ||
    activity.semanticActivityIdentity ||
    "Live session"
  );
}

export default function DurableFacilitatedSessionsList() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    async function loadSessions() {
      try {
        setLoading(true);
        const loadedSessions =
          await listDurableFacilitatedSessions();

        if (active) {
          setSessions(loadedSessions);
          setError("");
        }
      } catch (loadError) {
        if (active) {
          setError(
            "Captured sessions could not be loaded. Please try again."
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadSessions();

    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="app-section">
        <h1>Captured live sessions</h1>
        <p>Loading captured sessions...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app-section">
        <h1>Captured live sessions</h1>
        <p className="warning-message">{error}</p>
      </div>
    );
  }

  return (
    <div className="app-section">
      <h1>Captured live sessions</h1>
      <p>
        Review live facilitated sessions you captured for durable
        post-session review.
      </p>

      {sessions.length === 0 ? (
        <p>No captured live sessions yet.</p>
      ) : (
        <div className="app-table-container">
          <table className="app-table">
            <thead>
              <tr>
                <th>Captured</th>
                <th>Activity</th>
                <th>Participants</th>
                <th>Status</th>
                <th>Sample</th>
                <th>Warnings</th>
                <th>Review</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map((session) => (
                <tr key={session.durableSessionId}>
                  <td>{formatDate(session.capturedAt)}</td>
                  <td>{activityLabel(session.activity)}</td>
                  <td>{session.participantCount}</td>
                  <td>{session.captureStatus}</td>
                  <td>
                    {session.selectedSample?.sampleName ||
                      session.selectedSample?.selectedSampleId ||
                      "Unknown sample"}
                  </td>
                  <td>{session.warningCount || 0}</td>
                  <td>
                    <Link
                      to={`/app/durable-facilitated-sessions/${session.durableSessionId}`}
                    >
                      Open review
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
